import React from "react";
import { motion } from "framer-motion";
import {
  FaJava,
  FaJs,
  FaHtml5,
  FaCss3Alt,
  FaReact,
} from "react-icons/fa";
import {
  SiFlutter,
  SiCplusplus,
  SiDart,
} from "react-icons/si";

const ProfileModal = ({ onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
    <motion.div
      className="bg-[#1e1b4b] p-8 rounded-2xl text-white w-11/12 md:w-1/3 shadow-lg"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
    >
      <h2 className="text-2xl font-bold mb-3 text-indigo-400 text-center">
        About Me
      </h2>
      <p className="text-gray-300 mb-6 text-center text-sm">
        Hi, I’m <span className="text-indigo-400 font-semibold">Daniel</span> — a Software Engineer
        passionate about crafting interactive and efficient applications
        using modern technologies and clean UI design.
      </p>

      <h3 className="text-lg font-semibold mb-2 text-indigo-300 text-center">
        Languages
      </h3>
      <div className="flex justify-center flex-wrap gap-5 text-3xl mb-6">
        <FaJava className="hover:text-orange-400 transition" title="Java" />
        <SiCplusplus className="hover:text-blue-400 transition" title="C++" />
        <SiDart className="hover:text-cyan-400 transition" title="Dart" />
        <FaJs className="hover:text-yellow-400 transition" title="JavaScript" />
        <FaHtml5 className="hover:text-orange-500 transition" title="HTML" />
        <FaCss3Alt className="hover:text-blue-400 transition" title="CSS" />
      </div>

      <h3 className="text-lg font-semibold mb-2 text-indigo-300 text-center">
        Frameworks
      </h3>
      <div className="flex justify-center gap-6 text-3xl mb-4">
        <SiFlutter className="hover:text-sky-400 transition" title="Flutter" />
        <FaReact className="hover:text-cyan-400 transition" title="React" />
      </div>

      <div className="flex justify-center">
        <button
          onClick={onClose}
          className="mt-4 bg-indigo-500 px-5 py-2 rounded-lg hover:bg-indigo-600 transition"
        >
          Close
        </button>
      </div>
    </motion.div>
  </div>
);

export default ProfileModal;
